"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accounts = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _basis = require("basis");

var _reactRouterDom = require("react-router-dom");

var _components = require("../components");

var _hooks = require("../hooks");

var _types = require("../types");

var _actions = require("../context/actions");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// @ts-ignore
var getIncomeAccountsData = function getIncomeAccountsData(data, accounts, institutionName) {
  var incomeAccounts = data.customerSelectedCategories;
  return Object.keys(incomeAccounts).reduce(function (acc, key) {
    var _account$name, _account$bsb, _account$accountNumbe;

    var accountId = parseInt(key.split('-')[1], 10);
    var account = accounts.find(function (_ref) {
      var id = _ref.id;
      return id === accountId;
    });
    return [].concat((0, _toConsumableArray2.default)(acc), [{
      id: key,
      institutionName: institutionName,
      accountName: (_account$name = account === null || account === void 0 ? void 0 : account.name) !== null && _account$name !== void 0 ? _account$name : '',
      bsb: (_account$bsb = account === null || account === void 0 ? void 0 : account.bsb) !== null && _account$bsb !== void 0 ? _account$bsb : '',
      accountNumber: (_account$accountNumbe = account === null || account === void 0 ? void 0 : account.accountNumber) !== null && _account$accountNumbe !== void 0 ? _account$accountNumbe : '',
      income: incomeAccounts[key]
    }]);
  }, []);
};

var Accounts = function Accounts() {
  var history = (0, _reactRouterDom.useHistory)();
  var trackEvent = (0, _hooks.useEventTracker)();

  var _useContextSelector = (0, _hooks.useContextSelector)(function (ctx) {
    return {
      state: ctx.state,
      config: ctx.config,
      dispatch: ctx.dispatch
    };
  }),
      state = _useContextSelector.state,
      config = _useContextSelector.config,
      dispatch = _useContextSelector.dispatch;

  var accounts = state.accounts;
  var selectedAccounts = state.selectedAccounts;
  var institution = state.institution;
  var institutionName = (institution === null || institution === void 0 ? void 0 : institution.name) || '';
  var institutionSlug = (institution === null || institution === void 0 ? void 0 : institution.slug) || '';

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showPasswordForm = _useState2[0],
      setShowPasswordForm = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useStatementData = (0, _hooks.useStatementData)(institutionSlug, config.maxNumberStatementDays),
      getStatementDataRequest = _useStatementData.request,
      loading = _useStatementData.loading;

  var onStatementDataSuccess = (0, _react.useCallback)(function (outcome, accounts, institutionName) {
    var dataToIncomeAccountData = getIncomeAccountsData(outcome, accounts, institutionName);
    dispatch((0, _actions.setIncomeAccountData)(dataToIncomeAccountData));
    history.push(_types.Routes.income);
  }, [history, dispatch]);
  var onStatementDataNoIncomeFound = (0, _react.useCallback)(function () {
    history.push(_types.Routes.income);
  }, [history]);
  var getStatementData = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(selectedAccounts, password) {
      var _customerSelectedCate, outcome, failure, _failure$error2, _failure$error;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(getStatementDataRequest && accounts && institutionName && selectedAccounts)) {
                _context.next = 17;
                break;
              }

              trackEvent({
                action: 'poi-account-select',
                label: 'accounts.buttonSubmit'
              }, {
                numberOfAccountsSelected: selectedAccounts.length
              });
              _context.next = 4;
              return getStatementDataRequest(selectedAccounts, password);

            case 4:
              outcome = _context.sent;
              failure = outcome;

              if (!failure.error) {
                _context.next = 12;
                break;
              }

              if (!password) {
                _context.next = 10;
                break;
              }

              trackEvent({
                action: 'poi-error',
                label: (_failure$error = failure.error) === null || _failure$error === void 0 ? void 0 : _failure$error.error
              });
              return _context.abrupt("return", setError(failure.error));

            case 10:
              trackEvent({
                action: 'poi-error',
                label: (_failure$error2 = failure.error) === null || _failure$error2 === void 0 ? void 0 : _failure$error2.error
              });
              return _context.abrupt("return", setError({
                error: config.content.accounts.errorMessageFetchingData
              }));

            case 12:
              if (Object.keys((_customerSelectedCate = outcome === null || outcome === void 0 ? void 0 : outcome.customerSelectedCategories) !== null && _customerSelectedCate !== void 0 ? _customerSelectedCate : {}).length) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return", onStatementDataNoIncomeFound());

            case 14:
              onStatementDataSuccess(outcome, accounts, institutionName);
              _context.next = 19;
              break;

            case 17:
              trackEvent({
                action: 'poi-error',
                label: config.content.accounts.errorMessageCannotFetchData
              });
              return _context.abrupt("return", setError({
                error: config.content.accounts.errorMessageCannotFetchData
              }));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [getStatementDataRequest, onStatementDataSuccess, onStatementDataNoIncomeFound, config, accounts, institutionName, trackEvent]);

  var handleSelectAccounts = function handleSelectAccounts(accounts) {
    if (!(accounts !== null && accounts !== void 0 && accounts.length)) {
      return;
    }

    dispatch((0, _actions.setSelectedAccounts)(accounts));

    if (institution !== null && institution !== void 0 && institution.exportWithPassword) {
      return setShowPasswordForm(true);
    }

    void getStatementData(accounts);
  };

  var handleSubmitPassword = function handleSubmitPassword(password) {
    if (selectedAccounts) {
      void getStatementData(selectedAccounts, password);
    }
  };

  var handlePasswordFormGoBack = function handlePasswordFormGoBack() {
    setShowPasswordForm(false);
  };

  if (!accounts || !institution) {
    return null;
  }

  if (showPasswordForm) {
    var fieldProps = institution.credentials.find(function (_ref3) {
      var fieldID = _ref3.fieldID;
      return fieldID === 'password';
    });
    return fieldProps ? /*#__PURE__*/_react.default.createElement(_basis.Container, null, /*#__PURE__*/_react.default.createElement(_components.Header, {
      error: error,
      showSecureMessage: true
    }, /*#__PURE__*/_react.default.createElement(_components.TextContent, {
      path: "password.textTitle",
      vars: {
        institutionName: institutionName
      }
    })), /*#__PURE__*/_react.default.createElement(_basis.Container, {
      margin: "8 0 0 0"
    }, /*#__PURE__*/_react.default.createElement(_components.PasswordForm, {
      onSubmit: handleSubmitPassword,
      fieldProps: fieldProps,
      loading: loading,
      onGoBack: handlePasswordFormGoBack
    }))) : null;
  }

  return /*#__PURE__*/_react.default.createElement(_basis.Container, null, /*#__PURE__*/_react.default.createElement(_components.Header, {
    error: error
  }, /*#__PURE__*/_react.default.createElement(_components.TextContent, {
    path: "accounts.textTitle",
    vars: {
      institutionName: institutionName
    }
  })), /*#__PURE__*/_react.default.createElement(_basis.Text, null, /*#__PURE__*/_react.default.createElement(_components.TextContent, {
    path: "accounts.textInfo"
  })), /*#__PURE__*/_react.default.createElement(_basis.Container, {
    margin: "8 0 0 0"
  }, /*#__PURE__*/_react.default.createElement(_components.AccountsForm, {
    data: accounts,
    onSelectAccounts: handleSelectAccounts,
    loading: loading
  })), /*#__PURE__*/_react.default.createElement(_components.LoginAgainButton, null));
};

exports.Accounts = Accounts;